import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import {
  NudistaSemiBold13,
  NudistaSemiBold16,
  NudistaMedium12,
} from '../Common/Fonts'

const LoginForm = () => {
  const history = useHistory()
  return (
    <Wrapper>
      <LogoImage src='/images/loginScreen/photoid_logo.png' />
      <ColumnFlexWrapper gap='20'>
        <FormInputField
          type='email'
          icon='/images/loginScreen/email.svg'
          placeholder='Email Address'
        />
        <FormInputField
          type='password'
          icon='/images/loginScreen/password.svg'
          placeholder='Password'
        />
        <FormInputButton
          onClick={() => {
            history.push('/map-view')
          }}
        >
          <NudistaSemiBold13 white>LOGIN</NudistaSemiBold13>
        </FormInputButton>
      </ColumnFlexWrapper>
      <Icon bottom src='/images/navbar/uscope.png' alt='uscope' />

      <ColumnFlexWrapper gap='25'>
        <NudistaSemiBold16 white>Or Use Your Social Network</NudistaSemiBold16>
        <RowFlexWrapper gap='20'>
          <SocialLoginIconWrapper>
            <img
              width='11.9px'
              height='21.7px'
              src='/images/loginScreen/facebook.png'
              alt='facebook_icon'
            />
          </SocialLoginIconWrapper>
          <SocialLoginIconWrapper>
            <img
              width='25.6px'
              height='21.4px'
              src='/images/loginScreen/twitter.png'
              alt='twitter_icon'
            />
          </SocialLoginIconWrapper>
        </RowFlexWrapper>
        <ColumnFlexWrapper opacity='0.49' gap='15'>
          <NudistaMedium12 white>
            Don´t Have an Accout? Sign up.
          </NudistaMedium12>
          <NudistaMedium12 white>
            Forgot your password? Recover Here
          </NudistaMedium12>
          <VersionOvalDiv>
            <NudistaMedium12 white>V 4.0.16 (103)</NudistaMedium12>
          </VersionOvalDiv>
        </ColumnFlexWrapper>
      </ColumnFlexWrapper>
    </Wrapper>
  )
}

export default LoginForm

const LogoImage = styled.img``

const VersionOvalDiv = styled.div`
  height: 21px;
  padding: 0px 5px 0px 5px;
  border-radius: 21px;
  border: solid 1px #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const FormInputField = styled.input`
  background-image: url(${({ icon }) => icon});
  background-size: 22px 22px;
  background-repeat: no-repeat;
  background-position: 12px 0.6rem;
  padding-left: 50px;

  width: 52%;
  height: 42px;
  border-radius: 10px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  border: none;
  background-color: #ffffff;
  ::placeholder {
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
    text-align: left;
    color: linear-gradient(to bottom, #6f03fd -49%, #9838ca 120%);
  }
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
  color: #fff;
`

const FormInputButton = styled.button`
  width: 42%;
  height: 42px;
  border-radius: 8px;
  border: solid 1px #fff;
  background-color: transparent;
  cursor: pointer;
  font-family: Nudista;
  font-size: 13px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.08;
  letter-spacing: normal;
  text-align: center;
  color: #fff; ;
`
const Icon = styled.img`
  ${({ navbar, bottom, logout, logo }) => {
    if (navbar) {
      return `width: 17.7px;`
    } else if (bottom) {
      return ` width: 41px;
            margin-left: 23px;`
    } else if (logout) {
      return `width: 13.2px;
            `
    } else if (logo) {
      return `width: ${({ width }) => width};
            margin-top: -5px;`
    }
  }}
  transition: width 0.5s, margin 0.5s;
`

const SocialLoginIconWrapper = styled.div`
  border-radius: 50%;
  border: solid white 1px;
  width: 53px;
  height: 53px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const ColumnFlexWrapper = styled.div`
  gap: ${({ gap }) => gap}px;
  opacity: ${({ opacity }) => opacity};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const RowFlexWrapper = styled.div`
  gap: ${({ gap }) => gap}px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-top: 10vh;
  padding-bottom: 2vh;
  width: 28.5vw;
  height: 88vh;
  background-image: linear-gradient(to bottom, #6f03fd -49%, #9838ca 120%);
  @media (max-width: 1024px) {
    width: 38.5vw;
    @media (max-width: 768px) {
      width: 48.5vw;
      @media (max-width: 480px) {
        width: 100vw;
      }
    }
  }
`
